<template>
  <div @click="checkElementClicked($event)" :class="`${showPanel ? 'fixed inset-0 z-[99999] panel-container' : ''}`">
    <div :class="`fixed z-[99999] top-0 flex flex-col bg-white border-0 border-l border-solid border-gainsboro lg:max-w-[855px] max-w-[400px] w-[calc(100%-20px)] h-[100dvh] ${showPanel ? 'right-0' : 'right-[-870px]'}`" style="transition: 0.3s ease;">
      <!-- Header -->
      <div>
        <div class="border-0 border-b border-solid border-steam lg:py-[14px] lg:px-[24px] py-[24px] px-[16px] flex items-center justify-between lg:min-h-[77px]">
          <div class="flex items-center lg:gap-[12px] sm:gap-2.5 gap-1.5">
            <shipblu-icon @click="closePanel()" iconLibrary="material" iconClass="lg:text-3xl text-[22px] text-stone-cold cursor-pointer select-none" iconName="close" />
            <template v-if="orderType === 'exchanges'">
              <p class="text-black-wash font-medium lg:text-[22px] text-[18px] lg:ml-3 sm:ml-2 ml-1">{{ $t('Exchange order') }}</p>
            </template>

            <template v-else>
              <div class="text-black-wash font-medium lg:text-[22px] text-[18px] lg:ml-3 sm:ml-2 ml-1">
                <span>{{ $t('Tracking No.') + ' ' }}</span>
                <span>{{ orderData.tracking_number }}</span>
              </div>
              <shipblu-icon @click="copied(orderData.tracking_number)" iconLibrary="phosphor" iconClass="text-[22px] font-medium text-silver hover:text-primary cursor-pointer select-none" iconName="copy-simple" />
            </template>
          </div>

          <div v-if="orderType !== 'exchanges' " class="flex items-center gap-8">
            <div>
              <div v-if="orderData.delivery_attempts > 0" class="bg-pink-sparkle rounded-[5px] p-[16px] leading-4 text-fluorescent-red lg:flex hidden gap-[8px] items-center">
                <shipblu-icon iconLibrary="phosphor" iconClass="text-[16px] cursor-pointer select-none" iconName="warning" />
                <p class="text-[14px]">
                  <span>{{ orderData.delivery_attempts + '/3' + ' ' }}</span>
                  <span>{{ $t('attempts have been made') }}</span>
                </p>
                <shipblu-icon @click="orderData.delivery_attempts = 0" iconLibrary="material" iconClass="text-[16px] cursor-pointer select-none" iconName="close" />
              </div>
              <div class="mt-2" v-if="orderData.tracking_events && orderData.tracking_events.filter(item => item.comment && item.comment.includes('Customer refused to accept the shipment')).length > 0">
                <span class="text-blue-100 underline cursor-pointer" @click="RedirectToFOD()" v-if="feesOnOrder.length === 0 && $store.state.AppActiveUser.userRole === 'merchant'">{{ $t('Subscribe to FOD Collection') }}</span>
                <span class="text-blue-100 underline cursor-pointer" @click="RedirectTocashCollectino()" v-else>{{ $t('FOD Order') }}</span>
              </div>
            </div>
            <!-- Actions -->
            <vs-dropdown :disabled="shouldDisableButton" vs-trigger-click class="dd-actions cursor-pointer flex items-center">
              <span class="material-symbols-rounded lg:text-3xl text-2xl text-industrial-revolution">more_vert</span> 
              <vs-dropdown-menu style="width: 190px; z-index: 999990;">
                <div>
                  <!-- ACTIONS FOR CASH-COLLECTION -->
                  <vs-dropdown-item v-if="(orderType === 'cash-collections' && orderData.status === 'created') && ($store.state.AppActiveUser.userRole !== 'customer-support' && $store.state.AppActiveUser.userRole !== 'sales')" 
                    @click="confirmUpdateCashStatus(orderData, 'collection_requested')" >
                    <div class="flex items-center gap-2">
                      <feather-icon icon="DollarSignIcon" svgClasses="h-4 w-4" />
                      <span>{{$t('Request Collect')}}</span>
                    </div>
                  </vs-dropdown-item>

                  <!-- ALLOW CANCEL IF NOT DELIVERED OR RETURNED -->
                  <vs-dropdown-item v-if="(orderData.status === 'created' || orderData.status === 'pickup_requested' || orderData.status === 'collection_requested') && !orderData.fulfillment_provider_metadata && ((orderType === 'returns' && common.getPermissions('return_orders', 'base', 'cancel')) || (orderType === 'delivery-orders' && common.getPermissions('delivery_orders', 'base', 'cancel')))"
                    @click="orderType === 'cash-collections' ? updateCashStatus(orderData,'cancelled', 'cancel this order?') : updateShipmentStatus(orderData,'cancel this order?', 'cancelled')">
                    <div class="flex items-center gap-2">
                      <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" />
                      <span>{{ orderType === 'returns' || orderType === 'cash-collections' ? $t('Cancel Request') : $t('Cancel Shipment')}}</span>
                    </div>
                  </vs-dropdown-item>

                  <vs-dropdown-item v-if="((orderType === 'delivery-orders' && orderData.status === 'picked_up' || orderType === 'delivery-orders' && orderData.status === 'in_transit') || orderData.status === 'out_for_delivery' || orderData.status === 'delivery_attempted') && $store.state.AppActiveUser.userRole !== 'customer-support' && $store.state.AppActiveUser.userRole !== 'sales' && $store.state.AppActiveUser.userRole !== 'admin'"
                    @click="updateShipmentStatus(orderData, 'return this order to origin?', 'return_to_origin')">
                    <div class="flex items-center gap-2">
                      <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" />
                      <span>{{ $t('Return to Origin') }}</span>
                    </div>
                  </vs-dropdown-item>

                  <vs-dropdown-item v-if="$store.state.AppActiveUser.userRole === 'admin'"
                    @click="blockCustomer(orderData)">
                    <div class="flex items-center gap-2">
                      <feather-icon icon="UserXIcon" svgClasses="h-4 w-4" />
                      <span>{{ $t('Block Customer') }}</span>
                    </div>
                  </vs-dropdown-item>

                  <!-- ACTIONS FOR DELIVERED -->
                  <vs-dropdown-item v-if="orderData.status === 'delivered' && $store.state.AppActiveUser.userRole !== 'customer-support' && $store.state.AppActiveUser.userRole !== 'sales' && $store.state.AppActiveUser.userRole !== 'admin'"
                    @click="returnPackages('Return Packages', orderData)">
                    <div class="flex items-center gap-2">
                      <feather-icon icon="DeleteIcon" svgClasses="h-4 w-4" />
                      <span>{{$t('Pickup to Return')}}</span>
                    </div>
                  </vs-dropdown-item>

                  <vs-dropdown-item v-if="orderData.status === 'delivered' && $store.state.AppActiveUser.userRole !== 'customer-support' && $store.state.AppActiveUser.userRole !== 'sales' && $store.state.AppActiveUser.userRole !== 'admin'"
                    @click="returnPackages('Exchange Packages', orderData)">
                    <div class="flex items-center gap-2">
                      <feather-icon icon="Minimize2Icon" svgClasses="h-4 w-4" />
                      <span>{{$t('Pickup to Exchange')}}</span>
                    </div>
                  </vs-dropdown-item>


                  <!-- ACTIONS FOR CANCELLED -->
                  <vs-dropdown-item v-if="(orderData.status === 'cancelled') && $store.state.AppActiveUser.userRole !== 'customer-support' && $store.state.AppActiveUser.userRole !== 'sales' && $store.state.AppActiveUser.userRole !== 'admin'" 
                    @click="restartOrders(orderData)" >
                    <div class="flex items-center gap-2">
                      <feather-icon icon="RotateCcwIcon" svgClasses="h-4 w-4" />
                      <span>{{$t('Restart Shipment')}}</span>
                    </div>
                  </vs-dropdown-item>
                </div>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
        <div v-if="orderData.delivery_attempts > 0" class="lg:hidden mt-[16px] px-[16px]">
          <div class="bg-pink-sparkle rounded-[5px] p-[16px] leading-4 text-fluorescent-red flex gap-[8px] items-center justify-between">
            <shipblu-icon iconLibrary="phosphor" iconClass="text-[18px] cursor-pointer select-none" iconName="warning" />
            <p class="text-[14px] lg:font-normal font-medium">
              <span>{{ orderData.delivery_attempts + '/3' + ' ' }}</span>
              <span>{{ $t('attempts have been made') }}</span>
            </p>
            <shipblu-icon @click="orderData.delivery_attempts = 0" iconLibrary="material" iconClass="text-[18px] cursor-pointer select-none" iconName="close" />
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="mt-[16px] lg:hidden flex px-[16px] h-[45px] flex-shrink-0">
        <button 
          v-for="(tab, index) in tabs" :key="index"
          @click="activeTab = tab"
          :class="`w-full h-full outline-none border-0 border-b-2 border-solid text-[18px] font-medium rounded-t-[5px] ${activeTab === tab ? 'bg-carte-blanche text-primary border-primary' : 'bg-white text-industrial-revolution border-silver'}`"
        >
          {{ $t(tab) }}
        </button>
      </div>
      
      <!-- Body -->
      <div class="mt-[16px] flex-grow overflow-hidden flex">
        <!-- Order Timeline -->
        <div v-if="activeTab === 'Timeline' || screenWidth > 991" class="h-full border-0 lg:border-r border-solid border-gainsboro lg:w-[315px] w-full flex-shrink-0 flex flex-col gap-[16px]">
          <div class="flex items-center justify-between lg:px-[24px] px-[36px] flex-shrink-0">
            <p class="text-young-night text-[18px]">{{ $t('Timeline') }}</p>
            <p v-if="orderType !== 'exchanges'" class="rounded-[3px] font-bold text-[12px] px-[12px] py-[2.5px]" :style="`background: ${getStyle(orderData)+'35'}; color: ${getStyle(orderData)}`">{{ $t(getStatusLabel(orderData)) }}</p>
          </div>

          <div ref="timelineContainer" class="flex-grow overflow-y-auto overflow-x-hidden lg:px-[24px] px-[36px] py-[12px]">
            <div v-if="!lastStatuses.includes(orderData.status) && !exchangeStatus.filter(item => item.value === 'exchanged')[0].date" class="relative ml-[15px] pl-[32px] w-full pb-[32px] border-0 border-l-2 border-solid border-jupiter">
              <div class="absolute left-[-15.75px] flex items-center justify-center bg-white w-[29px] h-[29px] flex-shrink-0 rounded-full border-[2px] border-dashed border-silver">
                <div class="w-[15px] h-[15px] flex-shrink-0 rounded-full bg-jupiter"></div>
              </div>
              <p class="inline-block mb-[10px] text-[14px] capitalize py-[4px] px-[16px] rounded-[50px] leading-[19px] border border-solid border-silver text-industrial-revolution">{{ $t(estimatedStatus) }}</p>
              <p class="text-industrial-revolution text-[12px]">{{ orderData.estimated_date ? ('Est. ' + new Date(orderData.estimated_date).toLocaleDateString('fr-FR') + ' ' + '(' + ($i18n.locale === 'en' ? common.gettingDate(orderData.estimated_date).split(',')[0] : common.gettingDate(orderData.estimated_date).split('،')[0]) + ')') : '' }}</p>
            </div>

            <template v-if="orderType === 'exchanges' && orderData.delivery_order">
              <div v-for="(item, index) in exchangeStatus.filter(item => item.date).reverse()" :key="index">
                <div :class="`relative ml-[15px] pl-[32px] w-full border-0 border-l-2 border-solid ${index !== exchangeStatus.filter(item => item.date).length - 1 ? 'border-stoic-white pb-[32px]' : 'border-white'}`">
                  <div v-if="!lastStatuses.includes(item.value)" class="absolute left-[-15.75px] flex items-center justify-center bg-white w-[29px] h-[29px] flex-shrink-0 rounded-full border-[4px] border-solid border-stoic-white">
                    <shipblu-icon iconLibrary="material" iconClass="text-2xl text-primary" iconName="check" />
                  </div>
                  <div v-else class="absolute left-[-15.75px] flex items-center justify-center bg-white w-[29px] h-[29px] flex-shrink-0 rounded-full border-[2px] border-dashed border-primary">
                    <div class="w-[15px] h-[15px] flex-shrink-0 rounded-full bg-primary"></div>
                  </div>

                  <p class="inline-block mb-[10px] text-[14px] capitalize py-[4px] px-[16px] rounded-[50px] leading-[19px]" :style="`border: 1px solid ${item.color}; color: ${item.color};`">{{ item.title }}</p>
                  <p class="text-[12px] text-industrial-revolution">
                    <span>{{ new Date(item.date).toLocaleDateString('fr-FR') + ' ' }}</span>
                    <span>{{ new Date(item.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).replace(' ', '') }}</span>
                  </p>
                </div>
              </div>
            </template>
            
            <template v-else>
              <div v-for="(item, index) in trackings" :key="index">
                <div :class="`relative ml-[15px] pl-[32px] w-full border-0 border-l-2 border-solid ${index !== trackings.length - 1 ? 'border-stoic-white pb-[32px]' : 'border-white'}`">
                  <div v-if="!lastStatuses.includes(item.status)" class="absolute left-[-15.75px] flex items-center justify-center bg-white w-[29px] h-[29px] flex-shrink-0 rounded-full border-[4px] border-solid border-stoic-white">
                    <shipblu-icon iconLibrary="material" iconClass="text-2xl text-primary" iconName="check" />
                  </div>
                  <div v-else class="absolute left-[-15.75px] flex items-center justify-center bg-white w-[29px] h-[29px] flex-shrink-0 rounded-full border-[2px] border-dashed border-primary">
                    <div class="w-[15px] h-[15px] flex-shrink-0 rounded-full bg-primary"></div>
                  </div>

                  <div class="flex items-center gap-2 mb-[10px]">
                    <p class="inline-block text-[14px] capitalize py-[4px] px-[16px] rounded-[50px] leading-[19px]" :style="`border: 1px solid ${getOrderStatusColor(item)}; color: ${getOrderStatusColor(item)};`">{{ $t(getStatusLabel(item)) }}</p>
                    <shipblu-icon v-if="item.status === 'out_for_delivery' && item.user && item.user.use_whatsapp_relay === true && ['customer-support', 'ops-admin', 'admin'].includes($store.state.AppActiveUser.userRole)" @click="loadChat(item.user)" iconLibrary="phosphor" iconClass="text-primary text-xl cursor-pointer" iconName="chat-circle-text"></shipblu-icon>
                  </div>
                  
                  <p class="text-[12px] text-industrial-revolution">
                    <span v-if="$store.state.AppActiveUser.userRole !== 'merchant'">{{ item.user && (item.user.first_name + ' ' + item.user.last_name + ' ' + (item.user.hr_id ? `(${item.user.hr_id})` : '') + ' - ' ) }}</span>
                    <span>{{ new Date(item.created).toLocaleDateString('fr-FR') + ' ' }}</span>
                    <span>{{ new Date(item.created).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).replace(' ', '') }}</span>
                    <span v-if="callHistory.filter(element => element.attempt === item.id).length > 0">
                      <shipblu-icon @click="openLocalRingerModal(item.id)" iconLibrary="material" iconClass="ml-1 text-[14px] cursor-pointer" iconName="phonelink_ring" />
                    </span>
                  </p>

                  <div class="mt-[2px]" v-if="item.status === 'delivery_attempted' || item.status === 'collection_attempted' || item.status === 'return_attempted' || item.status === 'return_to_origin' || item.status === 'cod_change'">
                    <p class="text-[12px] text-[#E6194B]">{{ $t(item.comment) }}</p>
                    <div v-if="item.customer_validation !== null">
                      <div class="mt-[10px] mb-[8px] w-2/3 h-[1px] bg-super-silver"></div>
                      <p class="leading-[18px]">
                        <span :class="`${item.customer_validation ? 'bg-range-land' : 'bg-fluorescent-red'} inline-flex w-[11px] h-[11px] flex-shrink-0 rounded-full items-center justify-center`">
                          <shipblu-icon iconLibrary="material" iconClass="text-[9px] text-white mt-[1px]" :iconName="`${item.customer_validation ? 'check' : 'close'}`" />
                        </span>
                        <span :class="`${item.customer_validation ? 'text-range-land' : 'text-fluorescent-red'} text-[12px] leading-[18px]`">{{ ' ' + $t('Confirmed with myBlu app') }}</span>
                      </p>
                    </div>
                  </div>
                  <p v-if="item.status === 'return_to_origin' && orderData.rto_requested && $store.state.AppActiveUser.userRole === 'head-of-fleet' && localStorage.getItem('multipleWarehouses') === 'true'" @click="removeRTO()" class="mt-[2px] text-primary underline cursor-pointer text-[12px]">{{ $t('Release RTO') }}</p>
                </div>
              </div>
            </template>
          </div>

          <div class="lg:px-[24px] px-[36px] flex-shrink-0 mb-[20px]">
            <div v-if="localStorage.getItem('multipleWarehouses') === 'true' && ($store.state.AppActiveUser.userRole !== 'merchant' && $store.state.AppActiveUser.userRole !== 'customer-support' && $store.state.AppActiveUser.userRole !== 'finance' && $store.state.AppActiveUser.userRole !== 'sales')">
              <shipblu-button class="w-full" size="large" color="secondary" :textButton="$t('Add Tracking Event')" @click="openTrackingEventModal"/>
            </div>
            <div class="mt-[8px]" v-if="ringerHistory.length > 0 && ($store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'customer-support' || $store.state.AppActiveUser.userRole === 'manager' || $store.state.AppActiveUser.userRole === 'head-of-fleet' || $store.state.AppActiveUser.userRole === 'fc-operations-supervisor')">
              <span @click="callsHistoryModal = true" class="text-[12px] underline text-primary cursor-pointer">{{ $t('View All Ringer Recordings') }}</span>
            </div>
            <div class="mt-[8px]" v-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'customer-support' || $store.state.AppActiveUser.userRole === 'head-of-fleet'">
              <p @click="loadLogs" class="cursor-pointer text-primary text-[12px]"> 
                <feather-icon style="vertical-align: middle;" class="cursor-pointer mr-1" icon="DownloadIcon" svgClasses="h-4 w-4"/>
                <span class="underline">{{ $t('Export Logs') }} </span>
              </p>
            </div>
          </div>
        </div>

        <!-- Order Info -->
        <div ref="orderInfoContainer" v-if="activeTab === 'Info' || screenWidth > 991" class="h-full overflow-auto w-full lg:px-[24px] px-[16px]">
          <exchange-order v-if="orderType === 'exchanges'" class="mb-[16px]" :orderData="orderData"></exchange-order>
          <order-info v-if="orderType === 'delivery-orders' || orderType === 'returns'" class="mb-[16px]" :orderData="orderData" :merchantStatus="merchantStatus" :insurance="insurance" @loadOrder="loadOrder"></order-info>
          <customer-info class="mb-[16px]" :orderData="orderData" :merchantStatus="merchantStatus" @loadOrder="loadOrder"></customer-info>
          <package-info v-if="orderType === 'delivery-orders' || orderType === 'returns'" class="mb-[16px]" :orderData="orderData" :merchantStatus="merchantStatus" @loadOrder="loadOrder"></package-info>
          <order-price v-if="$store.state.AppActiveUser.userRole !== 'head-of-fleet'" class="mb-[16px]" :orderData="orderData" :merchantStatus="merchantStatus" @loadOrder="loadOrder"></order-price>
          <product-details class="mb-[16px]" v-if="orderData && ((orderData.buy_and_try_product_in_order && orderData.buy_and_try_product_in_order.length > 0) || (orderData.return_items && orderData.return_items.length > 0))" :orderData="orderData" />
        </div>
      </div>
    </div>

    <!-- Calls History PROMPT -->
    <shipblu-prompt
      class="tracking-modal"
      @close="callsHistoryModal = false"
      @cancel="callsHistoryModal = false"
      :active.sync="callsHistoryModal"
      :title="$t('Calls History')"
      :buttons-hidden="true"
    >
      <vs-collapse class="ringer-collapse p-0">
        <vs-collapse-item class="mb-2 pb-2" v-for="(item, index) in ringerHistory.filter((value, index, self) => index === self.findIndex((item) => (item.created.split('T')[0] === value.created.split('T')[0])))" :key="index">
          <div slot="header">
            <p class="font-semibold text-base">
              <span class="text-primary">{{ new Date(item.created).toLocaleDateString('fr-CA') }}</span>
              <span class="text-darkgray ml-1">{{ '(' + daysDic[new Date(item.created.split('T')[0]).getDay()] + ')' }}</span>
            </p>
          </div>
          <div v-for="(record, index) in ringerHistory.filter(element => element.created.split('T')[0] === item.created.split('T')[0])" :key="index">
            <div v-if="record.recording_file_link">
              <audio class="w-full h-12 mt-2" controls :src="record.recording_file_link"></audio>
              <p class="text-sm font-medium text-black text-right px-5">
                <span class="mr-2">{{ new Date(record.created).toLocaleTimeString() }}</span>
                <span>{{ item.caller.first_name }} {{ item.caller.last_name }}</span>
              </p>
            </div>
          </div>
        </vs-collapse-item>
      </vs-collapse>
      <div class="text-center mt-5">
        <button @click="callsHistoryModal = false" class="active-btn btn w-3/5">{{ $t('Done') }}</button>
      </div>
    </shipblu-prompt>

    <!-- Chat PROMPT -->
    <shipblu-prompt
      class="shipment-modal chat z-[999991]"
      @close="closeChatModal"
      :active.sync="chatModal"
      :title="'Chat with Agent'"
      :buttons-hidden="true">
      <div>
        <div v-if="chatLoader" class="flex items-center justify-center h-8">
          <div class="w-6 h-6 rounded-full animate-spin border-2 border-solid border-primary border-t-transparent"></div>
        </div>
        <div class="flex flex-col gap-4">
          <div v-for="message in chatMessages" :key="message.index">
            <div :class="`${message.senderType === 'AGENT' ? 'ml-auto text-right' : ''}`">
              <p class="font-medium text-[12px] capitalize">
                {{ message.senderType.toLowerCase() }}
              </p>
              <p :class="`${message.senderType === 'AGENT' ? 'ml-auto bg-primary text-white' : 'bg-beluga text-young-night'} text-[14px] mt-0.5 py-2 px-4 rounded-4xl w-[fit-content]`">
                {{ message.text }}
              </p>
              <p class="text-[12px] mt-0.5">
                <span>{{ new Date(message.timestamp).toLocaleDateString('fr-FR') + ' ' }}</span>
                <span>{{ new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).replace(' ', '') }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </shipblu-prompt>

    <!-- Local Ringer Modal -->
    <local-ringer-modal class="z-[999990]" :localRingerModal="localRingerModal" :attemptCalls="attemptCalls" @localRingerModal="localRingerModal = $event"/>

    <!-- Tracking Event Modal -->
    <tracking-event-modal :trackings="trackings" :addTrackingEventModal="addTrackingEventModal" :orderData="orderData" @addTrackingEventModal="addTrackingEventModal = $event" :warehouses="warehouses" @loadOrder="loadOrder"></tracking-event-modal>
  </div>
</template>

<script>
import { sendRequest, sendFulfillmentRequest } from '@/http/axios/requestHelper.js'
import i18nData from '@/i18n/i18nData.js'
import common from '@/assets/utils/common'
import LocalRingerModal from '../merchant-order-view/LocalRingerModal.vue'
import ShipbluPrompt from '@/layouts/components/ShipBluPrompt.vue'
import CustomerInfo from '../merchant-order-view/CustomerInfo.vue'
import OrderInfo from '../merchant-order-view/OrderInfo.vue'
import PackageInfo from '../merchant-order-view/PackageInfo.vue'
import OrderPrice from '../merchant-order-view/OrderPrice.vue'
import ProductDetails from '../merchant-order-view/ProductDetails.vue'
import ExchangeOrder from '../order-view/ExchangeOrder.vue'
import TrackingEventModal from '../merchant-order-view/TrackingEventModal.vue'

export default {
  props: ['showPanel', 'merchantStatus', 'orderDataInfo'],
  data () {
    return {
      common,
      localStorage,
      screenWidth: window.innerWidth,
      orderType: '',
      orderData: {
        linked_exchange_order: {
          delivery_order: {},
          return_order: {}
        },
        visit_dates: [],
        request_price: {
          total: 0,
          subtotal: 0,
          vat: 0,
          postal_tax: 0
        },
        failure_data: [],
        merchant: {
          subscription: {}
        },
        customer: {
          full_name: '',
          phone_number: '',
          address: {
            zone: {
              city: {
                governorate: {}
              }
            }
          }
        },
        created: '',
        packages: [],
        preferred_window:[],
        pickup_point: {},
        order_price: {
          total: 0,
          subtotal: 0,
          vat: 0,
          postal_tax: 0
        }
      },
      fulfillment: {
        products: [],
        flags: []
      },
      warehouses: [],
      fulfillmentSubscription: false,
      tabs: ['Timeline', 'Info'],
      activeTab: 'Timeline',
      trackings: [],
      ringerHistory: [],
      callHistory: [],
      attemptCalls: [],
      localRingerModal: false,
      callsHistoryModal: false,
      estimatedStatus: '',
      lastStatuses: ['delivered', 'returned', 'exchanged', 'collected'],
      isCounterDropOff: false,
      insurance: {},
      fulfillmentOrderId: '',
      daysDic: {
        '0':'Sunday',
        '1':'Monday',
        '2':'Tuesday', 
        '3':'Wednesday',
        '4':'Thursday', 
        '5':'Friday',
        '6':'Saturday'
      },
      exchangeStatus: [
        {
          title: 'Created',
          value: 'created',
          color: '#1E1E1E',
          date: ''
        },
        {
          title: 'Picked up to Exchange',
          value: 'picked up to exchange',
          color: '#0A3266',
          date: ''
        },
        {
          title: 'Swapping',
          value: 'swapping',
          color: '#C7B060',
          date: ''
        },
        {
          title: 'Exchanged',
          value: 'exchanged',
          color: '#31A9B0',
          date: ''
        }
      ],
      addTrackingEventModal: false,
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      lastOffset: '',
      chatModal: false,
      chatMessages: [],
      prevData: [],
      chatLoader: false,
      selectedAgent: {},
      actualData: {},
      feesOnOrder: []
    }
  },
  watch: {
    '$route.query.order' (val) {
      if (val) {
        this.orderType = this.orderDataInfo ? common.defineOrderType(this.orderDataInfo) : this.$route.path.split('/').filter(Boolean).pop()
        this.estimatedStatus = this.orderType === 'delivery-orders' ? 'delivered' : this.orderType === 'returns' ? 'returned' : this.orderType === 'exchanges' ? 'exchanged' : 'collected' 
        this.loadOrder()
        this.$nextTick(() => {
          if (this.$refs.orderInfoContainer) this.$refs.orderInfoContainer.scrollTop = 0
          if (this.$refs.timelineContainer) this.$refs.timelineContainer.scrollTop = 0
        })
      }
    },
    chatModal (val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            const container = document.querySelector(
              '.con-vs-dialog.shipment-modal.chat .vs-dialog .vs-dialog-text'
            )
            if (container) {
              container.scrollTop = container.scrollHeight
              container.addEventListener('scroll', this.onChatScroll)
            }
          }, 100)
        })
      }
    }
  },
  computed: {
    shouldDisableButton () {
      const role = this.$store.state.AppActiveUser.userRole
      const status = this.orderData.status
      const type = this.orderType

      const restrictedStatuses = [
        'reattempt_delivery', 'out_for_return', 'return_requested',
        'out_for_pickup', 'return_attempted', 'out_for_collection',
        'collection_attempted', 'failed', 'pickup_rescheduled', 'collected'
      ]

      const isMerchant = role === 'merchant'
      const isSupport = role === 'customer-support'
      const isSales = role === 'sales'

      if (this.merchantStatus === 'on_hold') return true

      if (isMerchant) {
        return (
          restrictedStatuses.includes(status) ||
          (type === 'delivery-orders' && status === 'returned') ||
          (type === 'returns' && (status === 'picked_up' || status === 'in_transit')) ||
          ((type === 'returns' || type === 'cash-collections') && status === 'cancelled')
        )
      }

      if (isSupport) {
        return (
          (status !== 'created' && status !== 'pickup_requested') ||
          type === 'cash-collections'
        )
      }

      if (isSales) {
        return status !== 'created' && status !== 'pickup_requested'
      }
      
      if (this.$route.name.includes('merchant-view')) {
        return true
      }

      return false
    }
  },
  methods: {
    updateCashStatus (data, status, sentence) {
      this.$emit('updateCashStatus', {data, status, sentence})
    },
    confirmUpdateCashStatus (data, status) {
      this.$emit('confirmUpdateCashStatus', {data, status})
    },
    onChatScroll (event) {
      const container = event.target
      if (container.scrollTop === 0 && this.prevData.length > 0 && !this.chatLoader) {
        this.chatLoader = true
        this.loadChat()
        container.scrollTop = 10
      }
    },
    loadChat (agent) {
      this.selectedAgent = agent ? agent : this.selectedAgent
      sendRequest(false, false, this, `api/v1/chat/customers/${this.orderData.customer.phone}/agents/${this.selectedAgent.id}/messages/?limit=${this.maximumItems}&offset=${this.lastOffset}`, 'get', null, true,
        (response) => {
          this.chatModal = true
          this.chatLoader = false
          this.prevData = response.data.messages.reverse()
          this.chatMessages = [...this.prevData, ...this.chatMessages]
          this.lastOffset = response.data.messages[0].timestamp
        }
      )
    },
    closeChatModal () {
      this.chatModal = false
      this.lastOffset = ''
      this.chatMessages = []
    },
    blockCustomer (data) {
      this.$emit('blockCustomer', data)
    },
    returnPackages (title) {
      this.$emit('returnOrderPackages', {title, data: this.actualData})
    },
    restartOrders (data) {
      this.$emit('restartOrders', data)
    },
    updateShipmentStatus (data, sentence, status) {
      this.$emit('updateShipmentStatus', {data, sentence, status})
    },
    openTrackingEventModal () {
      this.$validator.resume()
      this.addTrackingEventModal = true
    },

    checkElementClicked (event) {
      if (event.target.classList.contains('panel-container')) {
        this.closePanel()
      }
    },
    closePanel () {
      const query = Object.fromEntries(
        Object.entries(this.$route.query).filter(([key]) => key !== 'order' && key !== 'tracking_number')
      )
      this.$router.replace({ query }).catch(() => {})
      this.$emit('orderData', this.orderData)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    async copied (data) {
      try {
        await navigator.clipboard.writeText(data)
      } catch ($e) {
        this.$vs.notify({
          color: 'dark',
          title: i18nData[this.$i18n.locale]['cannot copy!'],
          position: 'bottom-center'
        })
      }
    },
    loadOrder () {
      sendRequest(false, false, this, `api/v1/${this.orderType ? this.orderType : this.$route.fullPath.toLowerCase().includes('returns') ? 'returns' : 'delivery-orders'}/${this.$route.query.order}/`, 'get', null, true, 
        (response) => {
          this.orderData = response.data
          if (this.orderType === 'delivery-orders') this.actualData = {...response.data, packages: response.data.packages.filter(item => !item.count)}
          if (this.orderType === 'exchanges') {
            this.exchangeStatus.forEach((item, index) => {
              switch (index) {
              case 0:
                item.date = this.orderData.created
                break
              case 1:
                item.date = this.orderData.delivery_order.pickup_date
                break
              case 2:
                item.date = this.orderData.delivery_order.delivered_date
                break
              case 3:
                item.date = this.orderData.return_order.returned_date
                break
              }
            })
          } else {
            this.isCounterDropOff = this.orderData.is_counter_dropoff
            if (this.orderData.merchant_insurance_package) {
              this.insurance = this.orderData.merchant_insurance_package
            }
            if (this.orderData.fulfillment_provider_metadata) {
              this.fulfillmentOrderId = this.orderData.fulfillment_provider_metadata.shipblu.order
              this.loadFulfillmentOrder()
            }
            if (this.$route.params.type === 'delivery-orders' || this.$route.params.type === 'returns') {
              this.orderData.pickup_point = `${this.orderData.pickup_point.address.line_1}, ${this.orderData.pickup_point.address.line_2} (${i18nData[this.$i18n.locale][this.orderData.pickup_point.address.zone.name] ? i18nData[this.$i18n.locale][this.orderData.pickup_point.address.zone.name] : this.orderData.pickup_point.address.zone.name})`
              this.orderData.return_point = this.orderData.return_point ? `${this.orderData.return_point.address.line_1}, ${this.orderData.return_point.address.line_2} (${i18nData[this.$i18n.locale][this.orderData.return_point.address.zone.name] ? i18nData[this.$i18n.locale][this.orderData.return_point.address.zone.name] : this.orderData.return_point.address.zone.name})` : ''
              this.orderData.cash = this.orderData.cash_amount
              this.orderData.cash_amount = this.orderData.cash_amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})
              this.orderData.declared_value = this.orderData.declared_value ? this.orderData.declared_value.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0
              if (this.$store.state.AppActiveUser.userRole === 'merchant' && localStorage.getItem('is_fulfillment') && localStorage.getItem('is_fulfillment') === 'true') {
                this.loadMerchantFulfillment()
              }
            }
            this.trackings = response.data.tracking_events.reverse()
            if (this.$store.state.AppActiveUser.userRole !== 'finance' && this.$route.params.type === 'cash-collections') {
              this.loadTrackingInfo()
            }
            if (this.$store.state.AppActiveUser.userRole === 'admin' || this.$store.state.AppActiveUser.userRole === 'customer-support' || this.$store.state.AppActiveUser.userRole === 'manager' || this.$store.state.AppActiveUser.userRole === 'head-of-fleet' || this.$store.state.AppActiveUser.userRole === 'fc-operations-supervisor') {
              this.loadRingerHistory()
            }
            this.orderData.failure_data = this.orderData.tracking_events.filter(item => (item.status === 'delivery_attempted' || item.status === 'return_attempted') && item.comment)
            if (this.orderData.failure_data.length > 0) {
              this.loadLocalRingerCall()
            }
            if (this.$store.state.AppActiveUser.userRole === 'merchant') this.loadFeesOnDelivery()
          }
        }, (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close()
          this.closePanel()
        }
      )
    },
    loadLocalRingerCall () {
      // this.ringerCardLoading = true
      sendRequest(true, false, this, `api/v1/ringer/local-ringer-call/?order=${this.$route.query.order}`, 'get', null, true, 
        response => {
          this.callHistory = response.data.results
          // this.ringerCardLoading = false
        }
      )
    },
    openLocalRingerModal (attemptID) {
      this.localRingerModal = true
      this.attemptCalls = this.callHistory.filter(element => element.attempt === attemptID)
    },
    removeRTO () {
      sendRequest(true, false, this, `api/v1/${this.orderType ? this.orderType : this.$route.fullPath.toLowerCase().includes('returns') ? 'returns' : 'delivery-orders'}/${this.$route.query.order}/`, 'patch', { rto_requested: false}, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.loadOrder()
        }
      )
    },
    loadRingerHistory () {
      sendRequest(true, false, this, `api/v1/ringer/agent-customer-call/?callee=${this.orderData.customer.id}`, 'get', null, true, 
        response => {
          this.ringerHistory = response.data.results
        }
      )
    },
    loadTrackingInfo () {
      sendRequest(true, false, this, `api/v1/tracking/cash-collections/?limit=50&cash_collection_request=${this.$route.params.orderID}`, 'get', null, true, 
        response => {
          this.trackings = response.data.results
        }
      )
    },
    loadMerchantFulfillment () {
      sendFulfillmentRequest(true, false, this, `api/v1/fc/merchants/${this.orderData.merchant.id}/`, 'get', null, true,
        () => {
          this.fulfillmentSubscription = true
        }, () => {}
      )
    },
    loadFulfillmentOrder () {
      const url = this.$route.params.type === 'returns' ? 'api/v1/fc/orders/inbound' : 'api/v1/fc/orders/outbound'
      sendFulfillmentRequest(true, false, this, `${url}/${this.fulfillmentOrderId}/`, 'get', null, true,
        (response) => {
          this.fulfillment = response.data
          this.fulfillment.products.map(item => { item.product.optionalLabel = `SKU: ${item.product.sku} . ${item.product.current_inventory_level} available` })
        }, () => {}
      )
    },
    formatWarehouses (warehouses) {
      warehouses.forEach(element => {
        if (!element.is_virtual) {
          this.warehouses.push(element)
        }
      })
    },
    loadLogs () {
      const query = `?limit=100&from=${this.orderData.created.split('T')[0]} ${this.orderData.created.split('T')[1].split('.')[0]}`
      sendRequest(true, false, this, `api/v1/${this.$route.params.type === 'cash-collections' ? 'cash-collection' : 'delivery-orders'}/${this.orderData.id}/logs/${query}`, 'get', null, true,
        (response) => {
          this.$vs.notify({
            color: 'success',
            title: i18nData[this.$i18n.locale]['Success'],
            text:response.data.message,
            position: 'top-center'
          })        
        }
      )
    },
    loadFeesOnDelivery () {
      sendRequest(true, false, this, `api/v1/merchants/${this.orderData.merchant.id}/fees-on-delivery/?governorate=${this.orderData.customer.address.zone.city.governorate.id}`, 'get', null, true,
        (response) => {
          this.feesOnOrder = response.data.results
        }
      )
    },
    RedirectTocashCollectino () {
      if (this.$store.state.AppActiveUser.userRole === 'head-of-fleet' || this.$store.state.AppActiveUser.userRole === 'manager') {
        this.$router.push({
          name:  `${this.$store.state.AppActiveUser.userRole}-search`,
          query: {
            search: `4${this.orderData.tracking_number}FOD`
          }
        }).catch(() => {})
      } else {
        this.$router.push({
          name: `${this.$store.state.AppActiveUser.userRole}-cash-collections-view`,
          query: {
            search: `4${this.orderData.tracking_number}FOD`
          }
        }).catch(() => {})
      }
    },
    RedirectToFOD () {
      this.$router.push({
        name: 'fees-on-delivery'
      }).catch(() => {})
    }
  },
  components: {
    LocalRingerModal,
    ShipbluPrompt,
    CustomerInfo,
    OrderInfo,
    PackageInfo,
    OrderPrice,
    ProductDetails,
    ExchangeOrder,
    TrackingEventModal
  },
  beforeDestroy () {
    // Clean up the event listener to avoid memory leaks
    const container = document.querySelector(
      '.con-vs-dialog.shipment-modal.chat .vs-dialog .vs-dialog-text'
    )
    if (container) {
      container.removeEventListener('scroll', this.onChatScroll)
    }
  },
  created () {
    if (this.$store.state.AppActiveUser.userRole !== 'merchant' && this.$store.state.AppActiveUser.userRole !== 'customer-support' && this.$store.state.AppActiveUser.userRole !== 'sales' && this.$store.state.AppActiveUser.userRole !== 'commercial-admin') {
      common.manageLoadWarehouses(this.formatWarehouses, this)
    }
    if (this.$route.query.order) {
      this.orderType = this.orderDataInfo || this.$route.query.tracking_number ? common.defineOrderType(Object.keys(this.orderDataInfo).length > 0 ? this.orderDataInfo : this.$route.query.tracking_number) : this.$route.path.split('/').filter(Boolean).pop()
      this.estimatedStatus = this.orderType === 'delivery-orders' ? 'delivered' : this.orderType === 'returns' ? 'returned' : this.orderType === 'exchanges' ? 'exchanged' : 'collected'
      this.loadOrder()
    }
    window.addEventListener('resize', () => { this.screenWidth = window.innerWidth })
  }
}
</script>

<style lang="scss">
.panel-container {
  transition: 0.5s ease;
  backdrop-filter: blur(4px);
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),
              linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}
div.tracking-modal {
  z-index: 999990 !important;
  .vs-dialog {
    max-width: 450px !important;
    .vs-dialog-text {
      padding-top: 0px;
    }
  }
}
.ringer-collapse {
  .vs-collapse-item--header {
    padding: 6px 8px !important;
    .icon-scale {
      transform: scale(1.2);
    }
  }
  .con-content--item {
    padding: 0px !important;
  }
}
.con-vs-dialog.shipment-modal.chat .vs-dialog {
  width: 400px !important;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  .vs-dialog-text {
    flex-grow: 1;
    overflow-y: auto;
  }
}
</style>